import { Component, HostBinding, Input } from '@angular/core';

/**
 * A single KPI square, as the Performances dashboard draws them. `key` is the i18n root: the label
 * is `<key>` and the tooltip `<key>-hint`, which is the convention every `dashboard.metrics.*` key
 * already follows.
 *
 * The host element carries `.square` itself so it stays the flex item of `.squares`: nesting the
 * div inside the component would leave the host unsized and collapse the row.
 */
@Component({
  selector: 'app-metric-tile',
  templateUrl: './metric-tile.component.html'
})
export class MetricTileComponent {
  @HostBinding('class.square') readonly isSquare = true;

  @Input() key: string;
  @Input() value = 0;
  @Input() isCurrency = false;
  @Input() format = '1.0-0';
}
